/* cs-p02-links.js
 * 預覽期的方便：P-02 區塊裡所有連到 /products/ 的連結補上 ?view=p02，讓客人（和我們）點進去仍然看到 p02 版產品頁。
 * 範圍：.cs-p02（系列頁、B3 繼續逛）與 .cs-p02-pair（產品頁的常一起用）底下的連結，含動態插進來的卡（系列頁換格、B3 補進來的卡）。
 * 🔴 範本正式指派給商品之後，商品頁本身就是 p02 版，上面這段「補 view」可以刪；但本檔檔尾另有 quick-view-button 的 focusout 防護（第三十四輪），
 *   不可整份刪：先把檔尾那段搬到另一支 p02 頁一定會載的檔，再刪這支與三處載入（cs-p02-collection、cs-p02-continue、cs-p02-main-product）。
 * 做法：初始掃一次；之後 MutationObserver 只處理「新增的元素節點」，我們自己改連結是改屬性、不是新增節點，所以不會自己觸發自己。
 * 已經有 view 參數的連結不動；只動同網域、路徑含 /products/ 的連結。
 */
(function () {
  'use strict';
  if (window.__csP02Links) { return; }
  window.__csP02Links = true;
  /* r39 止血：只有預覽期（當頁網址本身帶 view=p02…）才補。r38 起預設產品頁就是 p02 版，
     預設頁再補 view 會把真客人帶到 ?view=p02（吃 product.p02.json：英文 Share、沒有開箱區）。
     產品頁只認 view=p02 本身（產品只有 product.p02.json；view=p02-a 之類找不到範本會回到預設版，suffix 空白，
     Liquid 端不補，這裡也不能補——Codex r39hot-a）。系列頁有 p02-a／p02-c 預覽範本，照舊認 p02 開頭。 */
  var CUR_VIEW = '';
  try { CUR_VIEW = new URL(window.location.href).searchParams.get('view') || ''; } catch (e) { /* 舊瀏覽器：當成不是預覽 */ }
  var IS_PRODUCT = !!(document.body && /(^|\s)template-product(\s|$)/.test(document.body.className));
  if (IS_PRODUCT ? CUR_VIEW !== 'p02' : CUR_VIEW.indexOf('p02') !== 0) { return; }

  var A = 'a[href*="/products/"]';
  var SCOPE = '.cs-p02, .cs-p02-pair';
  var SCOPE_LINKS = '.cs-p02 ' + A + ', .cs-p02-pair ' + A;

  function fix(a) {
    var raw = a.getAttribute('href');
    if (!raw || raw.charAt(0) === '#') { return; }
    try {
      var u = new URL(raw, window.location.href);
      if (u.origin !== window.location.origin || u.pathname.indexOf('/products/') === -1) { return; }
      if (u.searchParams.has('view')) { return; }
      u.searchParams.set('view', 'p02');
      a.setAttribute('href', u.pathname + u.search + u.hash);
    } catch (e) { /* 網址解析不了：不動 */ }
  }

  function processNode(node) {
    if (!node || node.nodeType !== 1) { return; }
    var links = [];
    if (node.closest && node.closest(SCOPE)) {
      if (node.matches(A)) { links.push(node); }
      links = links.concat(Array.prototype.slice.call(node.querySelectorAll(A)));
    } else {
      links = Array.prototype.slice.call(node.querySelectorAll(SCOPE_LINKS));
    }
    links.forEach(fix);
  }

  function start() {
    Array.prototype.slice.call(document.querySelectorAll(SCOPE_LINKS)).forEach(fix);
    if (!window.MutationObserver) { return; }
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) {
        var added = ms[i].addedNodes;
        for (var j = 0; j < added.length; j++) { processNode(added[j]); }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();

/* quick-view-button 的 focusout 防護（第三十四輪，與上面的連結補丁無關，只是借這支檔載入）。
 * 為什麼放這裡：p02 頁只要有 v8 卡的按鈕（系列頁商品格與看更多、產品頁「繼續逛」），就一定載到這支檔
 *   —— cs-p02-collection.liquid 與 cs-p02-main-product.liquid 都無條件載入，cs-p02-continue.liquid 也載。
 *   assets/cs-p02-card.js 目前沒有任何 section 載入，cs-p02-collection／cs-p02-continue 各只載自己的 js，沒有第二支同時涵蓋兩種頁。
 * 🔴 上面說「本檔整份可以刪」：要刪之前必須先把這一段搬到另一支 p02 頁一定會載的檔，否則防護跟著消失。
 * 成因：global.js 的 MenuDrawer 對每個子類別都掛 focusout → onFocusOut，裡面 setTimeout 讀 this.mainDetailsToggle.hasAttribute('open')
 *   （global.js:847）。quick-view-button 繼承 MenuDrawer（quick-view.js:22），但按鈕裡沒有 <details>，mainDetailsToggle 是 null；
 *   v8 卡的按鈕帶 tabindex="0"（snippets/cs-card-v8.liquid:86），點下去會拿到焦點，抽屜一開焦點移走，focusout 觸發，就丟 TypeError。
 * 來源：首頁 sections/cs-g5b-variant-sheet.liquid:1116–1127 的同一段修法，邏輯逐字照抄；那個 section 不在 p02 範本裡，所以 p02 頁沒有這道防護。
 * 為什麼 global.js 不動：全站共用檔，不在 P-02 的施工範圍；改在我們自己的 p02 檔裡，在 document 的 capture 階段先攔下。
 * 影響範圍：只攔「事件目標在沒有 mainDetailsToggle 的 quick-view-button 裡」的 focusout；它本來就沒有東西可以關。
 *   有 <details> 的 MenuDrawer（選單、面板本體）mainDetailsToggle 不是 null，不被攔，照舊運作。
 *   但 stopPropagation 在 document capture 階段攔下後，這一次 focusout 之後所有的監聽都收不到（按鈕自己、祖先、document／window 的冒泡監聽，
 *   含主題 trapFocus 的 focusout 與 app 的監聽；同層其他 capture 監聽仍會執行）。這跟首頁正式站上那段邏輯相同（Codex r34a 指出範圍；第三十四輪前台驗 p02 頁的選單抽屜照常開關）。
 * 只掛一次：window.__csP02QvFocusGuard 旗標，腳本載入兩次也只掛一個監聽。 */
(function () {
  if (window.__csP02QvFocusGuard) { return; }
  window.__csP02QvFocusGuard = true;
  document.addEventListener('focusout', function (e) {
    var t = e.target, qb = t && t.closest ? t.closest('quick-view-button') : null;
    if (qb && !qb.mainDetailsToggle) e.stopPropagation();
  }, true);
})();
